export const CANCEL_SUBSCRIPTION_EVENT = 'cancelSubscription'

export const CANCEL_SUBSCRIPTION_STEPS = {
  REMIND: 'scp-remind',
  OPTION_SELECTION: 'scp-option-selection',
  GET_OFFER: 'scp-get-offer',
  CANCEL_AND_GET_FEEDBACK: 'scp-cancel-and-get-feedback',
  CANCELLED: 'scp-cancelled',
  END: 'scp-end',
}

export default {
  CANCEL_SUBSCRIPTION_EVENT,
  CANCEL_SUBSCRIPTION_STEPS,
}
